<template>
    <div class="grid">
        <div class="grid-content">
            <h1>Precios de costes</h1>
            <small>Aqui debe ir informacion relevante acerca de costos generados</small>
            <ul style="text-align: left">
                <li>Numero de llaves que se han activado</li>
                <li>Precio acumulado por acceso</li>
                <li>Habitaciones que no se le han habilitado la llave</li>
            </ul>
        </div>
    </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  data() {
    return {};
  },
  methods:{
    setLanguage(){
      if(localStorage.getItem('language')){
        console.log(localStorage.getItem('language'));
        i18n.locale = localStorage.getItem('language'); 
      }else{
        console.log("No hay lenaguaje");
      }
    }
  },
  created() {
      this.setLanguage();
  }
};
</script>

<style>
.grid {
  display: grid;
  grid-template-columns: 1fr 390px 1fr;
}

.grid-content {
    grid-column: 2/3;
}
</style>




// WEBPACK FOOTER //
// src/components/dashboard/children/Pricing.vue